export default __webpack_public_path__ + "static/media/page-visited-toolbox-old.2b16ece9.svg";